/**
* Adapted for Equalture!
**/

import NGTDialogPlayerEvent from "../NGTDialogPlayerEvent";
import AbstractCollaborationScreenMediator from "../../../view/AbstractCollaborationScreenMediator";
import ContentTypes from "../../../../../../../shared/lib/html5-software-library/src/ranj/eng/content/ContentTypes";
import { isNull } from "../../../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";

// ==============================================================================
// 
// ------------------- ABSTRACT DIALOG PLAYER MEDIATOR --------------------------
// 
// ==============================================================================

export class AbstractDialogScreenMediator extends AbstractCollaborationScreenMediator {

    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameAssets, gameModel) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, gameAssets, gameModel);

        this._onDialogContentBound = this._onDialogContent.bind(this);
        this._onDialogOptionsChangedBound = this._onDialogOptionsChanged.bind(this);
        this._onDialogOptionChosenBound = this._onDialogOptionChosen.bind(this);
        this._onDialogEndBound = this._onDialogEnd.bind(this);
    }

    destroy() {
        this._removeDialogPlayerListeners();
    }

    // Override these
    _handleTextContent() {}
    _handleAudioContent() {}
    _handleImageContent() {}
    _handleDialogOptionsChanged() {}
    _handleDialogOptionChosen() {}
    _handleOverlayImageContent() {}
    _handleMovieContent() {}

    // ------------------------------------------
    // 			Dialog listeners
    // ------------------------------------------

    _addDialogPlayerListeners() {
        if (isNull(this._dialogPlayer)) return;
        
        this._dialogPlayer.eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_CONTENT, this._onDialogContentBound);
        this._dialogPlayer.eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_OPTIONS_CHANGED, this._onDialogOptionsChangedBound);
        this._dialogPlayer.eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_OPTION_CHOSEN, this._onDialogOptionChosenBound);
        this._dialogPlayer.eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_END, this._onDialogEndBound);
    }

    _removeDialogPlayerListeners() {
        if (isNull(this._dialogPlayer)) return;
        
        this._dialogPlayer.eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_CONTENT, this._onDialogContentBound);
        this._dialogPlayer.eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_OPTIONS_CHANGED, this._onDialogOptionsChangedBound);
        this._dialogPlayer.eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_OPTION_CHOSEN, this._onDialogOptionChosenBound);
        this._dialogPlayer.eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_END, this._onDialogEndBound);
    }

    // ------------------------------------------
    // 			Dialog handlers
    // ------------------------------------------

    _onDialogContent({params}) {
        const dialogContentPackage = params.data.data;
        if (dialogContentPackage !== null) {
            //this._currentCharacterID = dialogContentPackage.characterID;
            const content = dialogContentPackage.content;
            switch (content.getType()) {
                case ContentTypes.TYPE_TEXT:
                    this._handleTextContent(content);
                    this._dialogPlayer.contentCompleted(content);
                    break;
                case ContentTypes.TYPE_AUDIO:
                    this._handleAudioContent(content);                    
                    break;
                case ContentTypes.TYPE_IMAGE:
                    this._handleImageContent(content);
                    this._dialogPlayer.contentCompleted(content);
                    break;
                case ContentTypes.TYPE_OVERLAY_IMAGE:
                    this._handleOverlayImageContent(content);
                    this._dialogPlayer.contentCompleted(content);    
                    break;
                case ContentTypes.TYPE_MOVIE:
                    this._handleMovieContent(content);                    
                    break;
                    
            }
        }
    }

    _onDialogOptionsChanged(event) {
         this._handleDialogOptionsChanged();
     }

    _onDialogOptionChosen({params}) {
        this._handleDialogOptionChosen(params.data.option);
    }

    _onDialogEnd(event) {
        this.setDialogPlayer(null);
    }

    // ------------------------------------------
    // 			Content delegates
    // ------------------------------------------

    getDialogPlayer() {
        return this._dialogPlayer;
    }

    setDialogPlayer(value) {
        if (this._dialogPlayer !== null) {
            this._removeDialogPlayerListeners();         
        }
                 
        this._dialogPlayer = value;
        
        if (this._dialogPlayer !== null) {
            this._addDialogPlayerListeners();
        }
    }

}
